import Img from 'components/Img';
import { iconTrustvoice } from 'graphics';

interface Props {
	className?: string;
}

export default function TrustvoiceLink({ className }: Props) {
	return (
		<p className={className}>
			<a
				href="https://trustvoice.com/"
				rel="nofollow"
				target="_blank"
				lang="en"
				className="inline-flex items-center gap-x-1 text-subtle hover:underline"
			>
				Verified by Trustvoice
				<Img src={iconTrustvoice} alt="" width={24} height={24} />
			</a>
		</p>
	);
}
TrustvoiceLink.displayName = 'TrustvoiceLink';
